import emojiRegex from "emoji-regex";
import { t } from "i18next";

export const validateSpecialCharacters = (fieldName: string) => {
  return (value: string) => {
    const regexp = emojiRegex();
    return regexp.test(value) ? t(`validation.${fieldName}.invalid`) : true;
  };
};
